import { getCoverSummary } from "../../services/CoverService";
import { Paths } from "../../constants/UrlConstants";
import {
  findDocuments,
  findRenewalDocuments
} from "./../../services/DocumentsService";
import idempotent from "./../../helpers/Idempotent";
import { redirectToErrorPageMessage } from "../../logging/CommonLogMessages";
import { trackException } from "../../logging/AppInsightsLogger";

export const SET_COVER_DETAILS = "SET_COVER_DETAILS";
export const SET_COVER_DOCUMENTS = "SET_COVER_DOCUMENTS";
export const SET_RENEWAL_DOCUMENTS = "SET_RENEWAL_DOCUMENTS";

const idempotentSetCoverSummary = idempotent();

export function setCoverSummary(membershipNumber, history, securityId) {
  return idempotentSetCoverSummary(
    membershipNumber,
    securityId
  )((dispatch) =>
    getCoverSummary(membershipNumber, securityId)
      .then((response) => {
        dispatch({
          type: SET_COVER_DETAILS,
          payload: {
            MembershipNumber: membershipNumber,
            SecurityId: securityId,
            PlanDates: response.data.PlanDates,
            Members: response.data.Members,
            BenefitSummaryYear: response.data.BenefitSummaryYear,
            IsDoubleExcessWarningPeriod:
              response.data.IsDoubleExcessWarningPeriod,
            HasSixWeeksBenefit: response.data.HasSixWeeksBenefit,
            HasGuidedOptionBenefit: response.data.HasGuidedOptionBenefit
          }
        });
      })
      .catch((error) => {
        trackException(
          redirectToErrorPageMessage,
          `Something went wrong while fetching cover summary. MembershipNumber: ${JSON.stringify(
            membershipNumber
          )}`
        );
        history.push(Paths.Error);
      })
  );
}

export function getCoverDocuments(membershipNumber) {
  return (dispatch) =>
    findDocuments(membershipNumber)
      .then((response) => {
        if (response) {
          dispatch({
            type: SET_COVER_DOCUMENTS,
            payload: {
              MembershipStatement: response.MembershipStatement,
              TravelDocuments: response.TravelDocuments,
              EnclosureDocuments: response.EnclosureDocuments,
              MembershipNumber: membershipNumber
            }
          });
        }
      })
      .catch((error) => {
        throw error;
      });
}

export function getRenewalDocuments(membershipNumber) {
  return (dispatch) =>
    findRenewalDocuments(membershipNumber)
      .then((response) => {
        if (response) {
          dispatch({
            type: SET_RENEWAL_DOCUMENTS,
            payload: {
              MembershipStatement: response.MembershipStatement,
              TravelDocuments: response.TravelDocuments,
              EnclosureDocuments: response.EnclosureDocuments,
              MembershipNumber: membershipNumber
            }
          });
        }
      })
      .catch((error) => {
        throw error;
      });
}
